import { useState, useCallback, useEffect } from 'react';

function useVisibilityChange(onChange) {
  let runAtFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const [isVisible, setVisible] = useState(true);
  const handleChange = useCallback(() => {
    onChange(!document.hidden);
    setVisible(!document.hidden);
  }, [onChange]);
  useEffect(() => {
    setVisible(!document.hidden);
  }, []);
  useEffect(() => {
    if (runAtFirst) {
      handleChange();
    }
  }, [handleChange, runAtFirst]);
  useEffect(() => {
    document.addEventListener('visibilitychange', handleChange);
    return () => {
      document.removeEventListener('visibilitychange', handleChange);
    };
  }, [handleChange]);
  return isVisible;
}

export { useVisibilityChange as default };
